export const _LOAD_MODEL_ = 'Load:Puzzle';
export const _SAVE_MODEL_ = 'Save:Puzzle';
export const _DELETE_PUZZLE_ = 'Delete:Puzzle';
export const _PUZZLE_CHOOSE_LEVEL_ = 'Puzzle:Choose-level';


export const TYPE_DEFAULT = {
  id: 1,
  name: 'Ca\u00e7a Texto',
  slug: 'caca-palavras',
};

export const MODEL = {
  id: null,
  name: '',
  slug: '',
  data: {},
  image: '',
  cat_id: null,
  type_id: 1,
  level_id: null,
  status_id: 1,
  status: {
    name: 'Rascunho',
    slug: 'draft',
  },
  type: TYPE_DEFAULT,
  published_date: null,
};
